import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 border-t border-purple-500/20 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {/* Column 1: Brand */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img src="/logo.svg" alt="AI BookMoney" className="h-8 w-auto" />
              <span className="text-xl font-bold text-white">AI BookMoney</span>
            </div>
            <p className="text-gray-400 mb-4">
              Complete Kindle Direct Publishing system. Turn AI books into real income.
            </p>
          </div>
          
          {/* Column 2: Tools & Resources */}
          <div>
            <h4 className="text-white font-semibold mb-4">Tools & Resources</h4>
            <ul className="space-y-2 text-gray-400 text-left">
              <li><Link to="/kdp-guide" className="hover:text-purple-400 text-left">KDP Publishing Guide</Link></li>
              <li><Link to="/master-amazon-kdp-with-ai" className="hover:text-purple-400 text-left">Master Amazon KDP with AI</Link></li>
              <li><Link to="/monetize-ai-books" className="hover:text-purple-400 text-left">How to Earn from AI Writing</Link></li>
              <li><Link to="/help" className="hover:text-purple-400 text-left">Help Center</Link></li>
            </ul>
          </div>
          
          {/* Column 3: Genre Guides - PSEO Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Popular Genres</h4>
            <ul className="space-y-2 text-gray-400 text-left text-sm">
              <li><Link to="/romance-book-cover-generator.html" className="hover:text-purple-400 text-left">Romance Book Tools</Link></li>
              <li><Link to="/how-to-write-fantasy-books.html" className="hover:text-purple-400 text-left">Fantasy Writing Guide</Link></li>
              <li><Link to="/mystery-book-book-creator.html" className="hover:text-purple-400 text-left">Mystery Book Creator</Link></li>
              <li><Link to="/business-book-cover-generator.html" className="hover:text-purple-400 text-left">Business Book Generator</Link></li>
              <li><Link to="/best-kdp-niches-2025" className="hover:text-purple-400 text-left">Best KDP Niches 2025</Link></li>
            </ul>
          </div>
          
          {/* Column 4: Support & Legal */}
          <div>
            <h4 className="text-white font-semibold mb-4">Support & Legal</h4>
            <ul className="space-y-2 text-gray-400 text-left">
              <li><Link to="/register" className="hover:text-purple-400 text-left">Start Free Trial</Link></li>
              <li><Link to="/support" className="hover:text-purple-400 text-left">Support</Link></li>
              <li><Link to="/terms" className="hover:text-purple-400 text-left">Terms of Service</Link></li>
              <li><Link to="/privacy" className="hover:text-purple-400 text-left">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2025 AI BookMoney. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;